type PartnerLike = { code: string; name: string; dcName?: string }

export const mapToPartnerFieldName = (
  partner: PartnerLike,
  shouldIncludeDcNameForSearch?: boolean
) => {
  return shouldIncludeDcNameForSearch
    ? `${partner.dcName}/${partner.code}/${partner.name}`
    : `${partner.code}/${partner.name}`
}
